let orderByDateFilter = () => {
    return (items) => {
        return _.orderBy(items, (item) => {
            return new Date(item.startDate);
        });
    };
};

export default orderByDateFilter;
